import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Customization } from '../../store/customization/model/customization.model';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CustomizationService {
    constructor(private http: HttpClient) {}

    loadCustomization(tenant: string): Observable<Customization> {
        return this.http.get<Customization>(`${environment.host}/skedflexContext`, {
            headers: {
                'X-Tenant-Id': tenant
            }
        });
    }
}
